import { useEffect } from 'react'
import { Outlet } from 'react-router'

import AppLoader from 'components/Loader/AppLoader/AppLoader'
import hocConnect from './hocMainLayout'

function MainLayout({ getToken, tokenLoading }) {
    useEffect(() => {
        // Check or request token
        getToken()
    }, [])

    return <>{tokenLoading ? <AppLoader /> : <Outlet />} </>
}

export default hocConnect(MainLayout)
